import { render, staticRenderFns } from "./NpsFeature.vue?vue&type=template&id=fcfc1390&scoped=true&"
import script from "./NpsFeature.vue?vue&type=script&lang=js&"
export * from "./NpsFeature.vue?vue&type=script&lang=js&"
import style0 from "./NpsFeature.vue?vue&type=style&index=0&id=fcfc1390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfc1390",
  null
  
)

export default component.exports